/*
 * Copyright (c) 2019 Promontory Interfinancial Network, LLC
 */

export enum PasswordCodeNotification {
  code_expired = 'CODE_EXPIRED',
  code_incorrect = 'CODE_INCORRECT',
  code_resent = 'CODE_RESENT',
  password_policy_violation = 'PASSWORD_POLICY_VIOLATION',
  too_many_tries = 'TOO_MANY_TRIES',
  try_again_later = 'TRY_AGAIN_LATER',
}
